import { render, staticRenderFns } from "./postBarList.vue?vue&type=template&id=542da971&scoped=true"
import script from "./postBarList.vue?vue&type=script&lang=js"
export * from "./postBarList.vue?vue&type=script&lang=js"
import style0 from "./postBarList.vue?vue&type=style&index=0&id=542da971&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542da971",
  null
  
)

export default component.exports